import React, { Children } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { fontWeights } from '../../theme/type';
import { body } from '../../styles/type';

const Td = styled.td`
  ${body.regular}
  padding: ${rem(16)};
  border-bottom: solid 1px ${colors.gray['200']};
  text-align: left;
  vertical-align: top;
  font-weight: ${fontWeights.regular};
  color: ${colors.gray['600']};
  text-align: center;

  &:not(:first-of-type) strong {
    color: ${colors.blue['500']};
    font-weight: ${fontWeights.semiBold};
  }
`;

const Check = styled.span`
  display: block;
  width: ${rem(12)};
  height: ${rem(12)};
  margin: auto;
  border-radius: 50%;
  background: ${({ active }) => (active ? colors.blue['500'] : colors.blue['50'])};
`;

const replaceChildrenWithComponent = (search, children, Component) => (
  Children.map(children, (child) => {
    if (child === search) {
      return <Component />;
    }
    if (typeof child === 'object' && child.props && child.props.children) {
      return React.cloneElement(child, {
        children: replaceChildrenWithComponent(
          search,
          child.props.children,
          Component
        )
      });
    }
    return child;
  })
);

const TableCell = ({ children }) => {
  let newChildren = replaceChildrenWithComponent(
    '{{checked}}',
    children,
    () => <Check active />
  );

  newChildren = replaceChildrenWithComponent(
    '{{unchecked}}',
    newChildren,
    Check
  );

  return (
    <Td>
      {newChildren}
    </Td>
  );
};

TableCell.propTypes = {
  children: PropTypes.node.isRequired
};

export default TableCell;
